import React, { useState, useEffect } from 'react';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import TrendGraphItemInfo from './TrendGraphItemInfo';
import { TrendManagementSettingType } from './TrendGraph';
import { LogD } from '../../../function/LogLapper';

const isDispLog: boolean = false;

type Props = {
  selectGroupNo: number;
  trendSettingList: TrendManagementSettingType[];
  onChangeTrandSettingData: (datas: TrendManagementSettingType[]) => void;
  onShowTrendSettingDialog: () => void;
};

const TrendGraphItemInfoList: React.FC<Props> = (props) => {
  LogD('==TrendGraphItemInfoList==', isDispLog);

  //表示チェックボックス選択
  const isShowOnChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    LogD('=isShowOnChange=', isDispLog);
    var tmp = props.trendSettingList;
    tmp[index].IsShow = tmp[index].IsShow == true ? false : true;
    props.onChangeTrandSettingData(tmp);
  };

  //背景選択
  const isRowSelectClick = (index: number) => {
    var tmp = props.trendSettingList;
    //console.debug(['= isRowSelectClick =', index, tmp,]);
    if (tmp[index].PLCNo !== '0') {
      tmp.forEach((row) => (row.IsRowSelect = false));
      tmp[index].IsRowSelect = true;
    }
    props.onChangeTrandSettingData(tmp);
  };

  //データチェックボックス
  const isDataSelectOnChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    var tmp = props.trendSettingList;
    if (tmp.filter((r) => r.IsDataSelect).length >= 3) {
      if (tmp[index].IsDataSelect == false) {
        //最大3件までしか選択できない
        console.debug([' IsDataSelect select max over']);
        return;
      }
    }
    tmp[index].IsDataSelect = tmp[index].IsDataSelect == true ? false : true;
    props.onChangeTrandSettingData(tmp);
  };

  return (
    <div style={{ display: 'flex' }}>
      {props.trendSettingList?.map((row, index) => (
        <TrendGraphItemInfo
          key={index}
          setData={row}
          isShowOnChange={isShowOnChange}
          isRowSelectClick={isRowSelectClick}
          isDataSelectOnChange={isDataSelectOnChange}
          isRowSelectDoubleClick={props.onShowTrendSettingDialog}
        />
      ))}
    </div>
  );
};

export default TrendGraphItemInfoList;
